module.exports = __webpack_public_path__ + "1793882494189/images/fa-regular-400.ba2a91d.svg";